module.exports = __webpack_public_path__ + "img/PK_full.079a68fe.png";